import template from 'text!./templates/file-upload-viewer.html';

let uploadInProgress = false; // Only one file upload dialog at a time

export default [
    () => ({
        'scope': {
            'uploadConfig': '=',
            'documents': '=',
            'dropZoneSelector': '&',
            'hideDropArea': '&',
            'removeFunction': '&'
        },
        'template': template,
        'controller': ['$scope', '$timeout', '$q', '$filter', 'ModalService', 'ViewModelService', 'InsuranceSuiteMetadata', ($scope, $timeout, $q, $filter, ModalService, ViewModelService, InsuranceSuiteMetadata) => {
            const invoiceDocumentType = InsuranceSuiteMetadata.get('cc').types.getTypelist('DocumentType').getCode("invoice_psa").code;

            const fileIcons = {
                doc: 'fa-file-word-o',
                docx: 'fa-file-word-o',
                docm: 'fa-file-word-o',
                pdf: 'fa-file-pdf-o',
                xlt: 'fa-file-excel-o',
                xlsx: 'fa-file-excel-o',
                xlsm: 'fa-file-excel-o',
                gif: 'fa-file-image-o',
                png: 'fa-file-image-o',
                jpeg: 'fa-file-image-o'
            };
            $scope.documentDTO = {};
            $scope.docVm = ViewModelService.create($scope.documentDTO, 'cc', 'edge.capabilities.claim.document.dto.ClaimDocumentDTO', { 'SubmittingClaim': true });

            if ($scope.uploadConfig.htmlFile === 'puw-more-info.html') {
                $scope.documentTypes = $scope.docVm.documentType.aspects.availableValues.filter(function (d) {
                    return d.code === 'quote_psa' || d.code === 'pictures_psa' ||
                        d.code === 'registrationcard_psa' || d.code === 'workorder_psa' || d.code === 'carmaintenanceproof_psa' || d.code === 'otherdoc_psa' ||
                        d.code === 'iban_psa' || d.code === 'diagnosis_psa' || d.code === 'videos_psa';
                });
            } else if ($scope.uploadConfig.htmlFile === 'create-invoice.html') {
                $scope.documentTypes = $scope.docVm.documentType.aspects.availableValues.filter(function (d) { return d.code === 'invoice_psa'; });
            } else {
                $scope.documentTypes = $scope.docVm.documentType.aspects.availableValues.filter(function (d) {
                    return d.code === 'quote_psa' || d.code === 'pictures_psa' || d.code === 'invoice_psa' ||
                        d.code === 'registrationcard_psa' || d.code === 'workorder_psa' || d.code === 'carmaintenanceproof_psa' || d.code === 'otherdoc_psa' ||
                        d.code === 'iban_psa' || d.code === 'diagnosis_psa' || d.code === 'videos_psa'
                })
            };

            $scope.documentNotFoundRedirectUrl = `${window.location.origin}${$scope.uploadConfig.documentNotFoundUrl}`;
            $scope.dragDropSelector = $scope.dropZoneSelector() || '.gw-file-upload-drag-area';
            $scope.removeDocument = (document) => {
                if (!document.canDelete) {
                    return;
                }
                const title = 'platform.widgets.fileupload.templates.Remove Document';
                const msg = $filter('translate')('platform.widgets.fileupload.templates.Are you sure you want to remove:', {
                    documentName: document.name
                });

                ModalService.showWarning(title, msg)
                    .result.then(() => {
                        $q.when($scope.removeFunction({ documentID: document.publicID }), (deleted) => {
                            if (deleted === true) {
                                // Filter out deleted doc
                                $scope.documents = $scope.documents.filter((doc) => doc.workingPublicID !== document.publicID);
                                if ($scope.uploadConfig.htmlFile === 'create-invoice.html') {
                                    $scope.uploadConfig.documents = $scope.documents;
                                }
                            } else {
                                ModalService.showError(
                                    'platform.widgets.fileupload.templates.Document Deletion May Have Failed',
                                    'platform.widgets.fileupload.templates.Something may have gone wrong when deleting your document.'
                                );
                            }
                        }, () => {
                            ModalService.showError(
                                'platform.widgets.fileupload.templates.Unable to Delete Document',
                                'platform.widgets.fileupload.templates.Sorry, your document could not be deleted at this time.'
                            );
                        });
                    });
            };

            $scope.getFileIcon = (file) => {
                const extension = _getFileExtension(file.docUID).toLowerCase() || '';
                return fileIcons[extension] || 'fa-file-o';
            };

            $scope.clickUpload = () => {
                // UCWAR - 777
                if ($scope.uploadConfig.htmlFile === 'create-invoice.html') {
                    var errorTitleUpload = undefined;
                    $scope.docVm.documentType.value = invoiceDocumentType;
                    if ($scope.documents.length >= 1) {
                        errorTitleUpload = 'platform.widgets.fileupload.templates.Only 1 invoice';
                    }
                    if (errorTitleUpload != undefined) {
                        ModalService.showError('gateway.views.modal.Error', errorTitleUpload);
                        return;
                    }
                }
                // Normal upload scenarios other than invoice screen        
                if (uploadInProgress || $scope.docVm.documentType.value != undefined) {
                    if (!uploadInProgress && !$scope.hideDropArea()) {
                        const uploadElement = $(`.${$scope.uploadConfig.uploaderClass} input`);
                        if (uploadElement.length !== 0) {
                            uploadInProgress = true;
                            // Wrap in timeout to call after current digest
                            $timeout(() => {
                                // Clicks the upload area to trigger the upload dialog
                                uploadElement[0].click();
                                uploadInProgress = false;
                            });
                        }
                    }
                } else {
                    const title = 'platform.widgets.fileupload.templates.Missing required field Document Type';
                    ModalService.showError('gateway.views.modal.Error', title);
                }
            };

            function _getFileExtension(name) {
                const extension = name.split('.').pop();
                return extension || '';
            }

            $scope.$watch('docVm.documentType.value', () => {
                documentTypeChanged();
            });

            function documentTypeChanged() {
                if ($scope.docVm.documentType.value != undefined) {
                    $scope.uploadConfig.metadataTemplate.DocumentType = $scope.docVm.documentType.value.code;
                }
            }

            //UCWAR-1390
            $scope.$on('fileuploaddone', (e, data) => {
                $scope.docVm.documentType.value = undefined;
                data.result.result.documentTypeName = $filter('translate')('platform.widgets.fileupload.templates.' + data.result.result.documentTypeName);
            });


            //UCWAR-1596 Type of doc is required for drag and drop
            $scope.$on('fileuploaddragover', (event) => {
                // UCWAR - 777
                if ($scope.uploadConfig.htmlFile === 'create-invoice.html') {
                    var errorTitleDragAndDrop = undefined;
                    $scope.docVm.documentType.value = invoiceDocumentType;
                    if ($scope.documents.length >= 1) {
                        errorTitleDragAndDrop = 'platform.widgets.fileupload.templates.Only 1 invoice';
                    }
                    if (errorTitleDragAndDrop != undefined) {
                        ModalService.showError('gateway.views.modal.Error', errorTitleDragAndDrop);
                        event.preventDefault();
                        event.stopPropagation();
                    }
                } else {
                    if ($scope.docVm.documentType.value == undefined) {
                        const title = 'platform.widgets.fileupload.templates.Missing required field Document Type';
                        ModalService.showError(title);
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            });
        }]
    })
];